import { OrganizationSubtitle } from 'pages/ScheduledGames/BpDialog/BpDialogStyles';
import styled, { css } from 'styled-components';
import { black, grey } from 'styles/Colors';

const DetailsText = css`
  font-family: Lato;
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.5px;
  color: ${grey};
`;

export const GameRow = styled.div`
  margin-top: 16px;
  &:not(:first-child) {
    margin-top: 25px;
  }
  display: flex;
  justify-content: space-between;
  position: relative;
  ${OrganizationSubtitle} {
    position: absolute;
    bottom: -16px;
    ${DetailsText}
  }
`;

export const ScheduledInfo = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;

  svg {
    margin-right: 10px;
  }
`;

export const Text = styled.span`
  opacity: 0.59;
  font-family: Lato;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.07;
  letter-spacing: 0.5px;
  color: ${black};
`;

export const GameSettings = styled.div`
  margin-bottom: 37px;
`;

export const Title = styled.div`
  color: #414141;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.2px;
`;
